import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import { merge } from "lodash";

function EchartsBase({ option }) {
  const dom = useRef();
  const [myChart, setMyChart] = useState();
  useEffect(() => {
    setMyChart(echarts.init(dom.current));
  }, [dom]);
  useEffect(() => {
    if (!option || !myChart) return;
    const opt = {
      backgroundColor: "white",
      title: {
        text: "",
        top: 8,
        left: 8,
      },
      legend: {
        show: true,
        icon: "circle",
        bottom: 6,
        left: 6,
      },
      yAxis: {},
      dpr: 2,
    };
    myChart.dpr = 2;
    myChart.setOption(merge(opt, option), true);
  }, [option, myChart]);
  useEffect(() => {
    if (!myChart) {
      return;
    }
    const flag = () => {
      myChart.resize();
    };
    window.addEventListener("resize", flag);
    return () => {
      window.removeEventListener("resize", flag);
    };
  }, [myChart]);

  return <div style={{ height: "100%", width: "100%" }} ref={dom}></div>;
}

export default EchartsBase;
